const TicketIcon = ({ clr, count, height, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 25"
    width={width || 25}
    height={height || 25}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="#C48D28"
        d="M17.803 3.062a.833.833 0 0 1 1.02.59l1.187 4.426a2.083 2.083 0 1 0 1.078 4.025l1.187 4.427a.833.833 0 0 1-.59 1.02L7.197 21.434a.833.833 0 0 1-1.021-.59L4.99 16.418a2.083 2.083 0 0 0-1.079-4.025L2.725 7.965a.833.833 0 0 1 .59-1.02l14.488-3.883Z"
      />
    </g>
    {/* <path
      fill="#FFFDEA"
      d="m10.047 16.118-.192-1.152c1.352-1.184 2.228-2.064 2.628-2.64.4-.584.6-1.18.6-1.788 0-.48-.112-.824-.336-1.032-.216-.216-.568-.324-1.056-.324-.264 0-.512.028-.744.084a3.425 3.425 0 0 0-.612.204l-.312-.816c.288-.136.62-.252.996-.348a4.736 4.736 0 0 1 1.176-.144c.912 0 1.576.184 1.992.552.424.36.636.924.636 1.692 0 .744-.264 1.44-.792 2.088-.528.648-1.436 1.424-2.724 2.328h3.684v1.296h-4.944Z"
    /> */}
    <text x="9" y="16" fill="#075063" font-size="12" font-weight="700">
      {count}
    </text>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.252 5.176 19.571 0l5.176 19.319L5.43 24.495z" />
      </clipPath>
    </defs>
  </svg>
);

export default TicketIcon;
